import {
    ReactElement,
} from 'react';

import {
    SimpleGrid,
    Table,
} from '@mantine/core';

import {useParams} from 'react-router-dom';
import {useOrganizationAccounts} from '../hooks/useOrganizationAccounts.ts';

import {
    RowSelectionDataCell,
    SimpleTableBatchAction,
    SimpleTablePagination,
    TableBody,
    TableBodyColumn,
    TableHeaderColumn,
    TableHeaderRow,
} from '@flexinet/ui-components';
import {useOrganizationAccountsSelection} from '../hooks/useOrganizationAccountsSelection.ts';
import {IOrganizationAccountTableColumn,} from '../types';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {useOrganizationAccountsPaging} from "../hooks/useOrganizationAccountsPaging.ts";
import {useOrganizationAccountsSearch} from "../hooks/useOrganizationAccountsSearch.ts";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()
    const {id: organizationId} = useParams();

    const {
        columns,
        visibleItems,
        loading,
    } = useOrganizationAccounts(organizationId ? {organizationId} : {});

    const {
        limit,
        totalPages,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useOrganizationAccountsPaging();

    const {
        handleFilterByKeyword,
    } = useOrganizationAccountsSearch();

    const {
        selection,
        handleRowSelection,
        handleSelectAllRows,
    } = useOrganizationAccountsSelection();
    const getColumns = () => {
        let cols: IOrganizationAccountTableColumn[] = [];
        if (allowedActions.includes('DeleteOrganizationAccount')) {

            cols.push({
                          id: 'select',
                          title: '',
                          render: (item: any) => {
                              return <RowSelectionDataCell item={item} handleChange={() => handleRowSelection(item.id, !selection[item.id])}/>;
                          },


                      },
            );
        }

        cols = cols.concat(columns);

        return cols;

    };


    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>
                <TableHeaderRow
                    columns={getColumns() as TableHeaderColumn[]}
                    handleSelectAllRows={() => handleSelectAllRows(!Object.keys(selection).length, visibleItems)}
                />
                <TableBody
                    items={visibleItems}
                    loading={loading}
                    selection={selection as any}
                    columns={getColumns() as TableBodyColumn[]}
                />
            </Table>

            <SimpleTablePagination
                totalPages={totalPages}
                visibleCount={totalCount}
                handlePageChange={handlePageChange}
            />
        </SimpleGrid>
    );
};
